import CityPageTemplate from "../city-template/CityPageTemplate";
import { lancasterConfig } from "./data";

export default function LancasterPage() {
  return <CityPageTemplate config={lancasterConfig} />;
}